import { DataProvider } from 'react-admin'
import { DeviceManagementItemDto } from '../../dto/device/device-management/device-management-items/DeviceManagementItem.dto'

const fakeItems: DeviceManagementItemDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeItems, total: fakeItems.length }),
} as DataProvider

export default provider
